import type {
  GetRecommendedProductRequest,
  GetRecommendedProductResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getRecommendedProduct = sendRequest<
  GetRecommendedProductRequest,
  GetRecommendedProductResponse
>({
  url: '/recommended_product',
  method: 'get',
});
